export const videos = [
  {
    id: 'v001',
    title: '夏日海边的绝美日出，这样的清晨太治愈了',
    slug: 'summer-beach-sunrise',
    category: 'travel',
    description: '凌晨四点起床，驱车两小时来到这片人迹罕至的海滩。当第一缕阳光穿透云层洒在海面上的那一刻，所有的疲惫都烟消云散。海角社区的清晨，永远值得期待。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Beautiful%20sunrise%20over%20a%20quiet%20tropical%20beach%20with%20soft%20golden%20light%20reflecting%20on%20calm%20ocean%20waves%2C%20warm%20peach%20and%20coral%20sky%2C%20silhouette%20of%20palm%20trees%2C%20peaceful%20morning%20atmosphere%2C%20cinematic%20photography%20style%20with%20soft%20natural%20lighting%2C%20dreamy%20and%20serene%20mood&width=800&height=450&seq=video-thumb-001&orientation=landscape',
    author: { name: '海风旅人', avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20man%20with%20warm%20smile%20casual%20outdoor%20portrait%2C%20clean%20minimal%20background%2C%20friendly%20approachable%20look%2C%20soft%20natural%20lighting%2C%20professional%20headshot%20style&width=100&height=100&seq=avatar-001&orientation=squarish' },
    views: '128.5万',
    likes: '9.8万',
    comments: '3.2万',
    duration: '08:24',
    publishDate: '2026-08-06',
    tags: ['日出', '海边', '旅行', '治愈', '清晨'],
    isHot: true,
    isNew: false,
    content: '详细内容：凌晨四点起床...',
  },
  {
    id: 'v002',
    title: '一分钟学会做正宗川味麻婆豆腐，麻辣鲜香超下饭',
    slug: 'sichuan-mapo-tofu-tutorial',
    category: 'food',
    description: '外婆教的麻婆豆腐秘方，今天分享给大家！关键在于豆瓣酱的炒制和花椒的选用。跟着步骤来，厨房小白也能做出饭店级别的麻婆豆腐。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Delicious%20sizzling%20mapo%20tofu%20in%20a%20traditional%20Chinese%20wok%20with%20red%20chili%20oil%20and%20green%20scallions%2C%20steaming%20hot%20on%20a%20wooden%20table%2C%20warm%20kitchen%20lighting%2C%20appetizing%20food%20photography%20with%20rich%20colors%20and%20textures%2C%20authentic%20Sichuan%20cuisine%20style&width=800&height=450&seq=video-thumb-002&orientation=landscape',
    author: { name: '厨房小当家', avatar: 'https://readdy.ai/api/search-image?query=Chinese%20female%20chef%20with%20warm%20smile%20in%20apron%2C%20clean%20kitchen%20background%2C%20friendly%20professional%20portrait%2C%20soft%20lighting%2C%20approachable%20cooking%20enthusiast&width=100&height=100&seq=avatar-002&orientation=squarish' },
    views: '256.3万',
    likes: '21.5万',
    comments: '5.8万',
    duration: '06:15',
    publishDate: '2026-08-05',
    tags: ['美食', '川菜', '麻婆豆腐', '家常菜', '烹饪教程'],
    isHot: true,
    isNew: false,
    content: '详细教程：麻婆豆腐的做法...',
  },
  {
    id: 'v003',
    title: '办公室社畜的欢乐日常，笑到肚子疼的第N天',
    slug: 'office-life-comedy',
    category: 'entertainment',
    description: '记录办公室那些让人哭笑不得的瞬间。从早会打瞌睡被老板抓包，到午饭时间抢最后一份红烧肉，每一天都是一部喜剧。海角社区视频最受欢迎的搞笑内容创作者来啦！',
    thumbnail: 'https://readdy.ai/api/search-image?query=Funny%20modern%20office%20scene%20with%20young%20Chinese%20professionals%20laughing%20and%20having%20fun%2C%20bright%20and%20airy%20workspace%20with%20computers%2C%20casual%20and%20relaxed%20atmosphere%2C%20warm%20natural%20lighting%2C%20comedic%20slice%20of%20life%20photography%20style&width=800&height=450&seq=video-thumb-003&orientation=landscape',
    author: { name: '社畜日记', avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20office%20worker%20with%20playful%20expression%2C%20casual%20portrait%2C%20clean%20background%2C%20friendly%20and%20fun%20personality%2C%20soft%20lighting&width=100&height=100&seq=avatar-003&orientation=squarish' },
    views: '189.6万',
    likes: '16.3万',
    comments: '7.1万',
    duration: '05:42',
    publishDate: '2026-08-04',
    tags: ['搞笑', '办公室', '日常', '社畜', '欢乐'],
    isHot: true,
    isNew: false,
    content: '办公室日常搞笑合集...',
  },
  {
    id: 'v004',
    title: '从零开始学吉他，和弦入门全攻略',
    slug: 'guitar-beginner-guide',
    category: 'music',
    description: '一把吉他，一个梦想。不管你是完全的零基础小白，还是想系统复习基本功，这个系列都会带你从最基础的持琴姿势开始，一步步走向弹唱自如。海角社区视频最受欢迎的吉他才艺创作者。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Acoustic%20guitar%20resting%20on%20a%20wooden%20stool%20near%20a%20sunlit%20window%20with%20warm%20golden%20afternoon%20light%2C%20cozy%20room%20interior%20with%20plants%2C%20musical%20and%20peaceful%20atmosphere%2C%20soft%20bokeh%20background%2C%20aesthetic%20music%20photography&width=800&height=450&seq=video-thumb-004&orientation=landscape',
    author: { name: '弦上时光', avatar: 'https://readdy.ai/api/search-image?query=Chinese%20male%20musician%20with%20artistic%20vibe%2C%20warm%20portrait%20with%20guitar%2C%20creative%20and%20inspiring%20look%2C%20soft%20natural%20lighting%2C%20friendly%20teacher%20personality&width=100&height=100&seq=avatar-004&orientation=squarish' },
    views: '95.2万',
    likes: '8.7万',
    comments: '4.3万',
    duration: '12:30',
    publishDate: '2026-08-03',
    tags: ['吉他', '音乐', '教程', '零基础', '弹唱'],
    isHot: false,
    isNew: true,
    content: '吉他入门详细教程...',
  },
  {
    id: 'v005',
    title: 'iPhone 16 Pro Max 深度体验一个月，值不值得买？',
    slug: 'iphone-16-pro-max-review',
    category: 'tech',
    description: '作为海角社区视频科技数码区的深度测评创作者，我使用了iPhone 16 Pro Max整整一个月。从续航、拍照、性能到日常体验，给你最真实的使用感受和购买建议。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Latest%20iPhone%20smartphone%20displayed%20on%20a%20clean%20minimal%20white%20desk%20with%20warm%20accent%20lighting%2C%20modern%20tech%20review%20setup%2C%20professional%20product%20photography%20with%20soft%20shadows%2C%20elegant%20and%20clean%20aesthetic&width=800&height=450&seq=video-thumb-005&orientation=landscape',
    author: { name: '数码极客Leo', avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20tech%20reviewer%20with%20glasses%2C%20modern%20casual%20style%2C%20friendly%20smart%20look%2C%20clean%20background%2C%20soft%20studio%20lighting%2C%20professional%20portrait&width=100&height=100&seq=avatar-005&orientation=squarish' },
    views: '312.8万',
    likes: '25.1万',
    comments: '9.6万',
    duration: '15:20',
    publishDate: '2026-08-02',
    tags: ['科技', '数码', 'iPhone', '评测', '手机'],
    isHot: true,
    isNew: false,
    content: 'iPhone 16 Pro Max详细评测...',
  },
  {
    id: 'v006',
    title: '篮球场上的逆天操作，每一个进球都让人尖叫',
    slug: 'amazing-basketball-highlights',
    category: 'sports',
    description: '海角社区视频体育频道精选——本期汇集了本月最精彩的街头篮球集锦。从超远三分到惊天暴扣，每一个瞬间都让人热血沸腾。这就是运动的魅力！',
    thumbnail: 'https://readdy.ai/api/search-image?query=Dynamic%20basketball%20action%20shot%20on%20outdoor%20court%20with%20golden%20sunset%20light%2C%20athletic%20player%20dunking%2C%20dramatic%20angle%2C%20urban%20street%20basketball%20atmosphere%2C%20energetic%20and%20inspiring%20sports%20photography&width=800&height=450&seq=video-thumb-006&orientation=landscape',
    author: { name: '球场老炮', avatar: 'https://readdy.ai/api/search-image?query=Chinese%20athletic%20basketball%20player%20portrait%2C%20sporty%20and%20energetic%20look%2C%20outdoor%20casual%20style%2C%20friendly%20and%20motivating%20vibe%2C%20soft%20natural%20lighting&width=100&height=100&seq=avatar-006&orientation=squarish' },
    views: '178.4万',
    likes: '14.2万',
    comments: '6.5万',
    duration: '04:55',
    publishDate: '2026-08-01',
    tags: ['篮球', '运动', '集锦', '扣篮', '街头'],
    isHot: false,
    isNew: true,
    content: '篮球精彩集锦合集...',
  },
  {
    id: 'v007',
    title: '探秘云南大理古城，寻找最地道的白族美食',
    slug: 'dali-ancient-city-food-tour',
    category: 'travel',
    description: '大理，一个来了就不想走的地方。这次海角社区视频旅行频道带你深入大理古城的小巷，寻找那些只有本地人才知道的地道白族美味。烤乳扇、酸辣鱼、喜洲粑粑...吃货必看！',
    thumbnail: 'https://readdy.ai/api/search-image?query=Ancient%20stone%20streets%20of%20Dali%20old%20town%20in%20Yunnan%20China%20with%20traditional%20architecture%20and%20warm%20lantern%20lights%2C%20colorful%20local%20food%20stalls%2C%20evening%20golden%20hour%20atmosphere%2C%20cultural%20and%20cozy%20travel%20photography&width=800&height=450&seq=video-thumb-007&orientation=landscape',
    author: { name: '海风旅人', avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20man%20with%20warm%20smile%20casual%20outdoor%20portrait%2C%20clean%20minimal%20background%2C%20friendly%20approachable%20look%2C%20soft%20natural%20lighting%2C%20professional%20headshot%20style&width=100&height=100&seq=avatar-001&orientation=squarish' },
    views: '143.7万',
    likes: '11.5万',
    comments: '4.8万',
    duration: '10:15',
    publishDate: '2026-07-30',
    tags: ['旅行', '大理', '美食', '云南', '古城'],
    isHot: false,
    isNew: false,
    content: '大理古城美食之旅...',
  },
  {
    id: 'v008',
    title: '周末宅家一天的治愈Vlog，慢生活太美好了',
    slug: 'weekend-stay-home-vlog',
    category: 'lifestyle',
    description: '一个普通周末的日常记录。打扫房间、给自己做一顿丰盛的早餐、窝在沙发里看书、傍晚去公园散步...没有惊天动地，只有平淡中的小确幸。海角社区视频生活频道最治愈的内容。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Cozy%20apartment%20interior%20with%20warm%20morning%20sunlight%20streaming%20through%20windows%2C%20plants%20and%20books%20on%20a%20wooden%20table%2C%20peaceful%20weekend%20atmosphere%2C%20minimalist%20and%20hygge%20lifestyle%20photography%2C%20soft%20and%20warm%20tones&width=800&height=450&seq=video-thumb-008&orientation=landscape',
    author: { name: '小鹿的生活', avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20woman%20with%20gentle%20smile%2C%20cozy%20home%20setting%2C%20warm%20and%20friendly%20portrait%2C%20soft%20natural%20lighting%2C%20approachable%20lifestyle%20creator&width=100&height=100&seq=avatar-008&orientation=squarish' },
    views: '98.1万',
    likes: '8.9万',
    comments: '5.2万',
    duration: '09:48',
    publishDate: '2026-07-29',
    tags: ['生活', 'Vlog', '治愈', '周末', '慢生活'],
    isHot: false,
    isNew: false,
    content: '周末宅家日常记录...',
  },
  {
    id: 'v009',
    title: '为什么我们总是忍不住刷短视频？心理学家深度解析',
    slug: 'why-we-cant-stop-short-videos',
    category: 'knowledge',
    description: '海角社区视频知识科普频道特邀心理学专家，从多巴胺机制到注意力经济学，用通俗易懂的方式解读短视频成瘾背后的科学原理。了解它，才能更好地掌控自己的生活。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20study%20room%20with%20books%20and%20a%20brain%20model%20on%20desk%2C%20warm%20reading%20lamp%20light%2C%20intellectual%20and%20calm%20atmosphere%2C%20knowledge%20and%20education%20themed%20photography%2C%20soft%20and%20focused%20lighting&width=800&height=450&seq=video-thumb-009&orientation=landscape',
    author: { name: '知识π', avatar: 'https://readdy.ai/api/search-image?query=Chinese%20scholar%20with%20thoughtful%20expression%2C%20intellectual%20and%20wise%20look%2C%20clean%20studio%20portrait%2C%20friendly%20educator%20style%2C%20soft%20lighting&width=100&height=100&seq=avatar-009&orientation=squarish' },
    views: '203.4万',
    likes: '18.7万',
    comments: '8.3万',
    duration: '11:05',
    publishDate: '2026-07-28',
    tags: ['科普', '心理学', '短视频', '知识', '自律'],
    isHot: true,
    isNew: false,
    content: '短视频成瘾心理学分析...',
  },
  {
    id: 'v010',
    title: '《原神》4.8版本新地图全收集攻略，宝箱一个不落',
    slug: 'genshin-4-8-map-guide',
    category: 'game',
    description: '海角社区视频游戏频道出品！4.8版本全新地图「夏末之岛」全收集攻略来了。从隐藏宝箱到解谜机关，手把手带你100%探索。跟着海角社区视频的游戏大神，轻松全成就！',
    thumbnail: 'https://readdy.ai/api/search-image?query=Colorful%20fantasy%20game%20landscape%20with%20magical%20floating%20islands%20and%20golden%20treasure%20chests%2C%20vibrant%20anime-style%20scenery%20with%20lush%20greenery%20and%20crystal%20clear%20waterfalls%2C%20adventure%20and%20exploration%20theme%2C%20bright%20and%20cheerful%20atmosphere&width=800&height=450&seq=video-thumb-010&orientation=landscape',
    author: { name: '游戏达人阿杰', avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20gamer%20with%20energetic%20smile%2C%20casual%20and%20fun%20portrait%2C%20friendly%20and%20enthusiastic%20look%2C%20clean%20background%2C%20soft%20lighting&width=100&height=100&seq=avatar-010&orientation=squarish' },
    views: '267.5万',
    likes: '22.3万',
    comments: '7.8万',
    duration: '18:42',
    publishDate: '2026-07-27',
    tags: ['游戏', '原神', '攻略', '宝箱', '探索'],
    isHot: true,
    isNew: false,
    content: '原神4.8全收集攻略...',
  },
  {
    id: 'v011',
    title: '零基础学街舞第一课：最基础的律动训练',
    slug: 'street-dance-basics',
    category: 'music',
    description: '想学街舞但不知从何开始？这个系列就是为你准备的！海角社区视频舞蹈频道的新人教程，从最简单的身体律动开始，不需要任何基础，跟着练就能找到节奏感。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Young%20dancer%20practicing%20in%20a%20bright%20modern%20dance%20studio%20with%20mirrors%20and%20wooden%20floor%2C%20energetic%20and%20dynamic%20pose%2C%20warm%20natural%20lighting%2C%20urban%20dance%20culture%20photography%20style&width=800&height=450&seq=video-thumb-011&orientation=landscape',
    author: { name: '弦上时光', avatar: 'https://readdy.ai/api/search-image?query=Chinese%20male%20musician%20with%20artistic%20vibe%2C%20warm%20portrait%20with%20guitar%2C%20creative%20and%20inspiring%20look%2C%20soft%20natural%20lighting%2C%20friendly%20teacher%20personality&width=100&height=100&seq=avatar-004&orientation=squarish' },
    views: '87.3万',
    likes: '7.5万',
    comments: '3.9万',
    duration: '07:30',
    publishDate: '2026-07-26',
    tags: ['街舞', '舞蹈', '教程', '零基础', '律动'],
    isHot: false,
    isNew: true,
    content: '街舞基础律动训练...',
  },
  {
    id: 'v012',
    title: '夏日清凉特饮合集，5款高颜值饮品在家做',
    slug: 'summer-refreshing-drinks',
    category: 'food',
    description: '夏天就要喝冰的！海角社区视频美食频道整理了5款超高颜值的夏日特饮，从经典莫吉托到网红葡萄冰萃，用料简单、做法超 easy，在家就能做出咖啡店同款。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Beautiful%20collection%20of%20colorful%20summer%20drinks%20in%20tall%20glasses%20with%20ice%20cubes%20and%20fresh%20fruit%20garnishes%2C%20bright%20and%20refreshing%20on%20a%20white%20marble%20countertop%2C%20sunny%20summer%20vibe%2C%20appetizing%20beverage%20photography&width=800&height=450&seq=video-thumb-012&orientation=landscape',
    author: { name: '厨房小当家', avatar: 'https://readdy.ai/api/search-image?query=Chinese%20female%20chef%20with%20warm%20smile%20in%20apron%2C%20clean%20kitchen%20background%2C%20friendly%20professional%20portrait%2C%20soft%20lighting%2C%20approachable%20cooking%20enthusiast&width=100&height=100&seq=avatar-002&orientation=squarish' },
    views: '176.2万',
    likes: '15.8万',
    comments: '4.1万',
    duration: '05:50',
    publishDate: '2026-07-25',
    tags: ['美食', '饮品', '夏日', '教程', '自制'],
    isHot: false,
    isNew: false,
    content: '夏日特饮制作教程...',
  },
];

export const featuredCreators = [
  {
    id: 'c001',
    name: '海风旅人',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20man%20with%20warm%20smile%20casual%20outdoor%20portrait%2C%20clean%20minimal%20background%2C%20friendly%20approachable%20look%2C%20soft%20natural%20lighting%2C%20professional%20headshot%20style&width=100&height=100&seq=avatar-001&orientation=squarish',
    bio: '旅行摄影师，用镜头记录世界的美好瞬间',
    followers: '52.6万',
    videos: 128,
    category: '旅行户外',
  },
  {
    id: 'c002',
    name: '厨房小当家',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20female%20chef%20with%20warm%20smile%20in%20apron%2C%20clean%20kitchen%20background%2C%20friendly%20professional%20portrait%2C%20soft%20lighting%2C%20approachable%20cooking%20enthusiast&width=100&height=100&seq=avatar-002&orientation=squarish',
    bio: '爱做饭的90后，教你轻松做出餐厅级美味',
    followers: '78.3万',
    videos: 215,
    category: '美食烹饪',
  },
  {
    id: 'c003',
    name: '数码极客Leo',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20tech%20reviewer%20with%20glasses%2C%20modern%20casual%20style%2C%20friendly%20smart%20look%2C%20clean%20background%2C%20soft%20studio%20lighting%2C%20professional%20portrait&width=100&height=100&seq=avatar-005&orientation=squarish',
    bio: '科技数码深度体验，给你最真实的购买建议',
    followers: '91.1万',
    videos: 89,
    category: '科技数码',
  },
  {
    id: 'c004',
    name: '游戏达人阿杰',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20gamer%20with%20energetic%20smile%2C%20casual%20and%20fun%20portrait%2C%20friendly%20and%20enthusiastic%20look%2C%20clean%20background%2C%20soft%20lighting&width=100&height=100&seq=avatar-010&orientation=squarish',
    bio: '主机游戏与手游双修玩家，攻略达人',
    followers: '65.8万',
    videos: 342,
    category: '游戏电竞',
  },
  {
    id: 'c005',
    name: '知识π',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20scholar%20with%20thoughtful%20expression%2C%20intellectual%20and%20wise%20look%2C%20clean%20studio%20portrait%2C%20friendly%20educator%20style%2C%20soft%20lighting&width=100&height=100&seq=avatar-009&orientation=squarish',
    bio: '把复杂知识讲得通俗易懂，人人都是终身学习者',
    followers: '43.2万',
    videos: 67,
    category: '知识科普',
  },
  {
    id: 'c006',
    name: '社畜日记',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20office%20worker%20with%20playful%20expression%2C%20casual%20portrait%2C%20clean%20background%2C%20friendly%20and%20fun%20personality%2C%20soft%20lighting&width=100&height=100&seq=avatar-003&orientation=squarish',
    bio: '每天分享办公室搞笑日常，治愈你的不开心',
    followers: '38.7万',
    videos: 156,
    category: '娱乐搞笑',
  },
];